<template>
  <div class="home">
    <AccountSetLayout layoutType="AccountSet" :layoutTitile="$t('MyWalletTitle')" >
      <BasiceLayout :title="$t('BankCard')" class='basicLayout'>
		 <!-- 银行卡 -->
        <div class="wallet-content">
          <div>
			  <!-- 户名 -->
            <div class="wallet-wrap">
              <span class="key">{{$t('bankAccountName')}}</span>
			  <div class="right-text">{{user_name}}</div>
            </div>
			<!-- 开户行 -->
			<div class="wallet-wrap">
			  <span class="key">{{$t('bankAddress')}}</span>
			  <input v-if="show" v-model="bankAddress" class="input wallet-input">
			  <div class="right-text" v-else>{{bankAddress}}</div>
			</div>
			<!-- 账号 -->
			<div class="wallet-wrap">
			  <span class="key">{{$t('bankAccount')}}</span>
			  <input v-if="show" v-model="bankAccount" class="input wallet-input">
			  <div class="right-text" v-else>{{bankAccount}}</div>
			</div>
			<div class="button wallet-bind" @click="commitBankInfo" v-if="show">确定</div>
			<div class="button wallet-bind" @click="editBankInfo" v-else>修改</div>
          </div>
        </div>		
      </BasiceLayout>
	   
	  <!-- 支付宝 -->
	  <BasiceLayout :title="$t('Alipay')" class='basicLayout'>
	    <div class="wallet-content">
	      <div>
			<!-- 姓名 -->
	        <div class="wallet-wrap">
	          <span class="key">{{$t('ZFBName')}}</span>
	          <div class="right-text">{{user_name}}</div>
	        </div>
			<!-- 支付宝账号 -->
			<div class="wallet-wrap">
			  <span class="key">{{$t('ZFBAccount')}}</span> 
			  <input v-if="show1" v-model="ZFBAccount" class="input wallet-input">
			  <div v-else class="right-text" >{{ZFBAccount}}</div>
			</div>
	  		<div class="button wallet-bind" @click="commitZFBInfo" v-if="show1">确定</div>
			<div class="button wallet-bind" @click="editZFBInfo" v-else>修改</div>
	      </div>
	    </div>
	  </BasiceLayout>
    </AccountSetLayout>
  </div>
</template>

<i18n>
{
  "en": {
    "MyWalletTitle": "Wallet Binding",
    "walletText": "Bundled Wallet Address",
		"newWalletText": "Bind Wallet Address",
		"inputPasswordText": "Enter Password",
		"walletTip": "Attention",
		"sureTips": "The wallet unbinding function will not be opened yet. Please check whether the bound wallet address is correct. If the cashier's address is incorrect, the cash will be lost, and BonusCloud will not bear any responsibility.",
    "unbindTips": "Are you sure to Unbunding? If authenticated, unbinding will fail",
    "unbindSuccess": "unbind success",
    "unbindError": "unbind error"
  },
  "zn": {
    "MyWalletTitle": "收款信息",
	"BankCard":"银行卡",
	"bankAccountName":"户名",
	"bankAddress":"开户行",
	"bankAccount":"账号",
	"Alipay":"支付宝",
	"ZFBName":"姓名",
	"ZFBAccount":"账号",
    "walletText": "当前绑定的钱包地址",
		"newWalletText": "绑定钱包地址",
		"inputPasswordText": "输入账号密码",
		"walletTip": "注意事项",
		"sureTips": "请认真核对绑定的钱包地址是否正确，若由于钱包地址错误导致提现失败，收益丢失，BonusCloud不承担任何责任。",
    "unbindTips": "是否确认解绑？钱包地址若已验证，解绑后验证失效",
    "unbindSuccess": "解绑成功",
    "unbindError": "解绑失败"
  }
}
</i18n>


<script>
import Header from '@/components/Header.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
import AccountSetLayout from '@/components/AccountSet/AccountSetLayout.vue'
import BasiceLayout from '@/components/Common/BasicLayout.vue'
import { Message } from 'element-ui'
import { LANG, SITEKEY } from '../../config/contant.js'

export default {
  name: 'home',
  components: {
    Header,
    BasiceLayout,
    AccountSetLayout,
  },
  computed: mapState({
    address: state => state.wallet.address,
    email: state => state.account.email,
    eth_verify_status: state => state.wallet.eth_verify_status
  }),
  data() {
    return {
      new_eth_address: '',
      inputEmailCode: '',
      response: '',
      sitekey: SITEKEY['LOW'], //ga verify key
      user_name:"",
      bankAddress:"",
      bankAccount:"",
      ZFBAccount:"",
      type: 'EDIT',
      show:true,
      show1:true,
    }
  },
  methods: {
    ...mapActions([
      'getCollection',
      'setCollection',
    ]),
    //点击提交银行卡信息 将更改的数据传给后台
    commitBankInfo (){
      let { bankAddress, bankAccount,user_name } = this;
      if(!user_name){
        this.$router.push({path:'/contact'});
        return Message({
          message:"请完成实名认证",
          type:"error",
        })
      }else if (!bankAddress || !bankAccount) {
        return Message({
          message: "请完整填写信息",
          type: "error",
        })
      }else{
        bankAccount = this.bankAccount.trim();
        bankAddress = this.bankAddress.trim();
        this.setCollection({
          bankAddress,
          bankAccount,
        }).then((res)=>{
          if (res.code === 200) {
            Message({
              message: "保存成功",
              type: "success",
            });
            this.getCollection();
             this.show = !this.show;
          } else {
            Message({
              message: res.message || "网络失败",
              type: "error",
            });
            this.getCollection();
            window.location.reload();
          }
        })
      }
    },
    //点击修改银行卡信息
    editBankInfo(){
      this.show = !this.show;	
    },
    //点击提交支付宝信息 将更改支付宝信息传给后台
    commitZFBInfo(){
      let { ZFBAccount,user_name } = this;
      if(!user_name){
        this.$router.push({path:'/contact'});
        return Message({
          message:"请完成实名认证",
          type:"error",
        })
      } else if(!ZFBAccount){
        return Message({
          message: "请完整填写信息",
          type: "error",
        })
      }else{
        ZFBAccount = this.ZFBAccount.trim();
        this.setCollection({
          ZFBAccount,
        }).then((res)=>{
          if(res.code == 200){	
            Message({
              message:"保存成功",
              type:"success",
            });
            this.getCollection();	
            this.show1 = !this.show1;
          }else{
            Message({
              message: res.msg || "网络失败",
              type: "error",
            });
              this.getCollection();
          }
        })
      }
    },
    //点击修改支付宝信息
    editZFBInfo(){
      this.show1 = !this.show1;
    },
    //封装获取收款信息
    updateCollection(){
      this.getCollection().then((res)=>{
        // let { bankAccount,user_name,ZFBAccount, bankAddress} = this;
        console.log(res.data);
        this.user_name = res.data.user_name;
        if(res.data.bankAddress&&res.data.bankAccount){
          this.bankAddress = res.data.bankAddress;
          this.bankAccount = res.data.bankAccount;
          this.show =!this.show;
        }
        if(res.data.ZFBAccount){
          this.ZFBAccount = res.data.ZFBAccount;
          this.show1 = !this.show1;
        }
      })
    }
  },
  created() {
    this.updateCollection();
  },
}
</script>

<style scoped lang="stylus">
.right-text {
	display:inline-block;
}

.email-bind-wrap span{
  height: 40px;
  line-height: 40px; 
}

.basicLayout {
	margin-top:20px;
}

.hard-captcha {
  height: 40px;
}

.captcha-bind-wrap {
  position: relative;
}

.captcha-bind-wrap .key {
  position: absolute;
  top: 0;
  left: 0;
  height: 70px;
  line-height: 70px; 
}

.hard-captcha {
  display: inline-block;
  padding-left: 200px;
}

.wallet-bind-title {
  color: #96999b;
  font-size: 20px;
}

.wallet-content {
  width: 800px;
  margin: 30px auto;
  text-align: left;
}

.wallet-wrap {
  width: 100%;
  position: relative;
  margin: 20px 0 30px;
}

.wallet-wrap .key {
  display: inline-block;
  width: 200px;
  color: #96999b;
}

.email-bind-wrap .wallet-email {
  position: absolute;
  top: 0;
  left: 200px;
}

.wallet-content #walletDetail {
  font-size: 18px;
  padding: 5px 10px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  width: 100%;
  margin-right: 50px;
  text-align: center;
}

.wallet-input {
  width: 460px;
  height: 40px;
}

body {
  height: 100%;
}

.wallet-bind {
  margin: 20px 0 0 355px;
}

.wallet-tips {
  margin-top: 20px;
}

.wallet-tips-wrap {
  text-align: left;
  width: 80%;
  padding: 8px 16px;
  margin: 40px 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  opacity: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  background-color: #f4f4f5;
  color: #909399;
  line-height: 30px;
}

.home {
  height: auto;
}


.unbind-wrap {
  display: flex;
  justify-content: center;
}
</style>

